import { render, staticRenderFns } from "./aside.vue?vue&type=template&id=393caea2&scoped=true"
import script from "./aside.js?vue&type=script&lang=js&external"
export * from "./aside.js?vue&type=script&lang=js&external"
import style0 from "./aside.scss?vue&type=style&index=0&id=393caea2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393caea2",
  null
  
)

export default component.exports